import React from "react";
import "./ProductItemCardThumb.scss";
import { RxCross2 } from "react-icons/all";
import productSelectionReducer from "../../../modules/product-selection/redux/product-selection.reducer";
import { useDispatch } from "react-redux";

const ProductItemCardThumb = ({ product, onClick }) => {
  const dispatch = useDispatch();

  const renderThumbCard = () => {
    if (product.foreignCurrency?.length > 0) {
      return (
        <div style={{ display: "flex" }}>
          {product.foreignCurrency.map((item) => {
            return (
              <div className="thumb-card-container" key={product.ProductName}>
                <div className="thumb-card">
                  <img src={product.ImageUrl} className="thumb-img" alt="" />
                  <div
                    className="crossIcon"
                    onClick={() => {
                      dispatch(
                        productSelectionReducer.actions.removeMultipleCurrencyThumbCard({
                          product: product,
                          remove: item,
                        }),
                      );
                      if (product.foreignCurrency.length === 1) {
                        dispatch(
                          productSelectionReducer.actions.setSelectedProductItem({
                            ProductCode: product.ProductCode,
                            isAllProductClear: false,
                          }),
                        );
                        dispatch(productSelectionReducer.actions.setIsCreditCardModalOpen(false));
                      }
                    }}>
                    <RxCross2 className="icon" />
                  </div>
                  <div className="title">
                    <div dangerouslySetInnerHTML={{ __html: product?.ProductName }} />
                  </div>
                  <span className="currency-type">{item ? item : product.Cur}</span>
                </div>
              </div>
            );
          })}
        </div>
      );
    } else if (product.foreignCurrency === undefined) {
      return (
        <div className="thumb-card-container" key={product.ProductName}>
          <div className="thumb-card">
            <img src={product.ImageUrl} className="thumb-img" alt="" />
            {onClick && (
              <div className="crossIcon" onClick={onClick && onClick}>
                <RxCross2 className="icon" />
              </div>
            )}
            <div className="title">
              <div dangerouslySetInnerHTML={{ __html: product?.ProductName }} />
            </div>
            <span className="currency-type">{product.Cur ? product.Cur : "LKR"}</span>
          </div>
        </div>
      );
    }
  };

  return <div>{renderThumbCard()}</div>;
};
export default ProductItemCardThumb;
